import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import ContentPageShareTab from "./ContentPageShareTab";
import ContentPageSharePublicLinks from "./ContentPageSharePublicLinks";
import { ContentPageShareAdditionalLinks } from "./ContentPageShareAdditionalLinks";
import { getDecodedHtml } from "utils/getDecodedHtml";
import { ContentPageShareExplanation } from "./ContentPageShareExplanation";
import { ContentPageShareExplanationMobileModal } from "./ContentPageShareExplanationMobileModal";
import { ShareContainer } from "components/context/share/ShareContext";
import * as PageResponsive from "components/utility/page-responsive/PageResponsive";
class ContentPageShare extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedTab:
				props.additionalLinks && props.publicLinks
					? props.publicLinks.label
					: props.additionalLinks
					? props.additionalLinks.label
					: props.publicLinks.label,
			isMobile: false,
			mobileTooltipFlag: false
		};
	}
	componentDidMount() {
		this.mobileTooltipHandler();
		window.addEventListener("resize", this.mobileTooltipHandler);
	}
	componentWillUnmount() {
		window.removeEventListener("resize", this.mobileTooltipHandler);
	}
	componentDidUpdate(prevProps, prevStates) {
		if (prevStates.mobileTooltipFlag !== this.state.mobileTooltipFlag) {
			this.props.setShareExplanationFlag(this.state.mobileTooltipFlag);
		}
	}
	selectedTabHandler = (label) => {
		this.setState({ selectedTab: label });
	};
	mobileTooltipHandler = () => {
		this.setState({ isMobile: PageResponsive.isMobile() });
	};
	getExplanationData = (selectedTab, publicLinks, additionalLinks) => {
		let explantionalData = {};
		if (publicLinks && selectedTab === publicLinks.label) {
			explantionalData = publicLinks.explanation || null;
		}
		if (additionalLinks && selectedTab === additionalLinks.label) {
			explantionalData = additionalLinks.explanation || null;
		}
		return explantionalData || null;
	};
	updateState = (values) => {
		this.setState(values);
	};
	render() {
		const {
			title,
			publicLinks = null,
			additionalLinks = null,
			footer,
			copyLabel,
			copyConfirm,
			mobileTooltipInitFlag = false,
			analytics = {}
		} = this.props;
		const { selectedTab, isMobile, mobileTooltipFlag } = this.state;
		const tabLabels =
			additionalLinks && publicLinks ? [publicLinks.label, additionalLinks.label] : null;
		const shareValue = {
			selectedTab: selectedTab,
			publicLinks: publicLinks,
			copyLabel: copyLabel,
			copyConfirm: copyConfirm,
			additionalLinks: additionalLinks,
			isMobile: isMobile,
			mobileTooltipFlag: mobileTooltipFlag,
			analytics,
			explanationData: this.getExplanationData(selectedTab, publicLinks, additionalLinks),
			updateState: this.updateState
		};
		return (
			<Fragment>
				<ShareContainer value={shareValue}>
					<div className="content-page-share">
						<div className="content-page-share-header">
							<div className="content-page-share-header-mask"></div>
							<div className="content-page-share-header-container">
								<h1 className="content-page-share-title h1-left-white">{title}</h1>
								{additionalLinks && publicLinks ? (
									<div className="content-page-share-tab" data-testid="content-page-share-tab">
										{tabLabels.map((label, index) => {
											return (
												<ContentPageShareTab
													label={label}
													onClick={() => this.selectedTabHandler(label)}
													selectedTab={selectedTab}
													key={index}
												/>
											);
										})}
									</div>
								) : null}
							</div>
						</div>
						{publicLinks && <ContentPageSharePublicLinks />}
						{additionalLinks && <ContentPageShareAdditionalLinks />}
						{footer && (
							<div className="content-page-share-footer">
								<ContentPageShareExplanation />
								<div dangerouslySetInnerHTML={{ __html: getDecodedHtml(footer) }}></div>
							</div>
						)}
					</div>
					{mobileTooltipInitFlag && <ContentPageShareExplanationMobileModal />}
				</ShareContainer>
			</Fragment>
		);
	}
	static propTypes = {
		isNormalShare: PropTypes.bool,
		title: PropTypes.string,
		theme: PropTypes.string,
		copyLabel: PropTypes.string,
		copyConfirm: PropTypes.string,
		publicLinks: PropTypes.shape({
			label: PropTypes.string,
			linkLabel: PropTypes.string,
			shareUrl: PropTypes.string,
			socialLinks: PropTypes.arrayOf(
				PropTypes.shape({
					label: PropTypes.string,
					imageUrl: PropTypes.string,
					Url: PropTypes.string
				})
			),
			explanation: PropTypes.shape({
				label: PropTypes.string,
				description: PropTypes.array
			})
		}),
		additionalLinks: PropTypes.shape({
			label: PropTypes.string,
			links: PropTypes.arrayOf(
				PropTypes.shape({
					label: PropTypes.string,
					Url: PropTypes.string
				})
			),
			explanation: PropTypes.shape({
				label: PropTypes.string,
				description: PropTypes.array
			})
		}),
		footer: PropTypes.string,
		mobileTooltipInitFlag: PropTypes.bool,
		setShareExplanationFlag: PropTypes.func
	};
}

export default ContentPageShare;
